import { render, staticRenderFns } from "./DrivingLicense.vue?vue&type=template&id=6d8f4420&"
import script from "./DrivingLicense.vue?vue&type=script&lang=js&"
export * from "./DrivingLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports